module.exports = __webpack_public_path__ + "img/MoonSword 2b.a083ea5d.png";